var map = {
	"./JadavpurUniversity_Logo.png": 60,
	"./JadavpurUniversity_Logo.svg.png": 61,
	"./abhranilbhattacharjee.jpeg": 62,
	"./abhranilbhattacharjee.png": 63,
	"./achievement-award-medal.png": 64,
	"./address_image.svg": 65,
	"./animated_ashutosh.png": 66,
	"./animated_logo.svg": 67,
	"./blogs_image.svg": 68,
	"./cloud_infrastructure.svg": 69,
	"./codeInLogo.png": 70,
	"./contactMail.png": 71,
	"./coursera_logo.png": 72,
	"./crioDo_logo.webp": 73,
	"./data_science.svg": 74,
	"./deeplearning_ai_logo.png": 75,
	"./delhivery_logo.png": 76,
	"./developerActivity.svg": 77,
	"./dsc_logo.png": 78,
	"./education.svg": 79,
	"./experience.svg": 80,
	"./feelingProud.svg": 81,
	"./freecopy_logo.png": 82,
	"./fullstack.svg": 83,
	"./gcp_logo.png": 84,
	"./github_logo.png": 85,
	"./goldmansachs_logo.png": 86,
	"./goldmansachs_logo.svg": 87,
	"./goldmansachs_logo_simple.svg": 88,
	"./googleAssistant.jpg": 89,
	"./googleAssistant.svg": 90,
	"./google_logo.png": 91,
	"./ibm_logo.png": 92,
	"./ibm_logo.svg": 93,
	"./ibm_logo_new.svg": 94,
	"./iiitk_logo.png": 95,
	"./intel_logo.jpg": 96,
	"./isi_logo.png": 97,
	"./iu_logo.png": 98,
	"./jadavpurUniversity.png": 99,
	"./java_logo.svg": 100,
	"./jsFramework.svg": 101,
	"./leetcode_logo.svg": 102,
	"./legato_logo.png": 103,
	"./manOnTable.svg": 104,
	"./microsoft_logo.png": 105,
	"./mozilla_logo.png": 106,
	"./muffito_logo.png": 107,
	"./myntra_logo.svg": 108,
	"./nextuLogo.jpg": 109,
	"./nodejs_logo.svg": 110,
	"./nptel_logo.jpeg": 111,
	"./nptel_logo.png": 112,
	"./paytm_logo.jpeg": 113,
	"./paytm_logo.svg": 114,
	"./paytm_logo_simple.svg": 115,
	"./player_silhouette.svg": 116,
	"./portfolio.gif": 117,
	"./programmer.svg": 118,
	"./projects_image.svg": 119,
	"./pwa.png": 120,
	"./rndTcs_logo.png": 121,
	"./saayaHealthLogo.png": 122,
	"./stanford_logo.png": 123,
	"./talksCardBack.svg": 124,
	"./talksCardBackAlt.svg": 125,
	"./tata_logo.svg": 126,
	"./tcs_logo.svg": 127,
	"./tcs_logo_simple.svg": 128,
	"./tiktok_logo.png": 129,
	"./ui_ux_design.svg": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;